@if(show()){
<div id="spinner" loading-widget class="admin-loading-widget">
    <img class="show-on-light" src="./assets/images/vud/spinners/spinner_doughnut_blue_light.svg" alt=""
        width="48" height="48">
    <img class="show-on-dark" src="./assets/images/vud/spinners/spinner_doughnut_blue_dark.svg" alt=""
        width="48" height="48">
</div>
}

